import {
	Button,
	Col,
	Form,
	Input,
	InputNumber,
	Row,
	Select,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner } from "../utils/CustomComponents";

const NewLogisticsTrip = (props) => {
	const [form] = Form.useForm();
	const [loading, setLoading] = useState(false);
	const [loadingForm, setLoadingForm] = useState(true);
	const [clientOptions, setClientOptions] = useState([]);
	const [truckOptions, setTruckOptions] = useState([]);
	const [driverOptions, setDriverOptions] = useState([]);
	const [mineOptions, setMineOptions] = useState([]);
	const [materialOptions, setMaterialOptions] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		Promise.all([
			getClients(),
			getDrivers(),
			getTrucks(),
			getMines(),
			getMaterials(),
		]).then(() => {
			setLoadingForm(false);
		});
	}, []);

	const getClients = async () => {
		const url = api + "/logistics/client/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setClientOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getDrivers = async () => {
		const url = api + "/logisticsdriver/list";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let driverList = [];
			data.map((item) => {
				driverList.push({
					label: item.name,
					value: item._id,
				});
			});
			setDriverOptions(driverList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getTrucks = async () => {
		const url = api + "/logisticstruck/list";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let truckList = [];
			data.map((item) => {
				truckList.push({
					label: item.number,
					value: item._id,
				});
			});
			setTruckOptions(truckList);
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getMines = async () => {
		const url = api + "/logistics/mine/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMineOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const getMaterials = async () => {
		const url = api + "/logistics/material/list/jap";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (data.success) {
				let list = [];
				data.payload.map((item) => {
					list.push({
						value: item._id,
						label: item.name,
					});
				});
				setMaterialOptions(list);
			} else {
				openNotification("error", "Error", data.message);
			}
		} catch (err) {
			console.error(err.message);
			return null;
		}
	};

	const createTrip = async (data) => {
		const trip = {
			ticket: data.ticket,
			mine: data.mine.label,
			mineId: data.mine.value,
			material: data.material.label,
			materialId: data.material.value,
			client: data.client.label,
			clientId: data.client.value,
			truck: data.truck,
			driver: data.driver,
			quantity: data.quantity,
		};

		try {
			let url = api + "/logisticstrip/create/jap";
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.post(url, trip);

			openNotification("success", "Success", "Trip Created");
			setTimeout(() => {
				setLoading(false);
				props.history.push("/logistics/dashboard");
			}, 2000);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to create trip");
			console.error(err.message);
			return null;
		}
	};

	const onFinish = (values) => {
		setLoading(true);
		createTrip(values);
	};

	const CustomForm = () => {
		return (
			<Form form={form} layout="vertical" onFinish={onFinish}>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Ticket"
							name="ticket"
							rules={[
								{
									required: true,
									message: "Ticket is required",
								},
							]}
						>
							<Input
								size="large"
								disabled={
									localStorage.getItem("email") !== "eliud@gmail.com" &&
									localStorage.getItem("email") !== "ec@57concrete.com" &&
									localStorage.getItem("email") !== "pc@57concrete.com" &&
									localStorage.getItem("email") !== "gg@57xgroup.com" &&
									localStorage.getItem("email") !== "scale@filegonia.com" &&
									localStorage.getItem("email") !== "jc@57concrete.com" &&
									localStorage.getItem("email") !== "reyesss22@icloud.com" &&
									localStorage.getItem("email") !== "office@57logistics.com"
								}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Origin"
							name="mine"
							rules={[
								{
									required: true,
									message: "Please select a origin",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select origin`}
								size="large"
								options={mineOptions}
								style={{
									width: "100%",
								}}
								labelInValue
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Driver"
							name="driver"
							rules={[
								{
									required: true,
									message: "Please select a driver",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select driver`}
								size="large"
								options={driverOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Truck"
							name="truck"
							rules={[
								{
									required: true,
									message: "Please select a truck",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select truck`}
								size="large"
								options={truckOptions}
								style={{
									width: "100%",
								}}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Material"
							name="material"
							rules={[
								{
									required: true,
									message: "Please select a material",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select material`}
								size="large"
								options={materialOptions}
								style={{
									width: "100%",
								}}
								labelInValue
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Destination"
							name="client"
							rules={[
								{
									required: true,
									message: "Please select a destination",
								},
							]}
						>
							<Select
								allowClear={false}
								placeholder={`Select destination`}
								size="large"
								options={clientOptions}
								style={{
									width: "100%",
								}}
								labelInValue
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Quantity"
							name="quantity"
							rules={[
								{
									required: true,
									message: "Quantity must be filled",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, "")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
				</Row>
			</Form>
		);
	};

	return (
		<Layout
			title="Logistics Trip"
			description="Create Logistics Trip"
			type="medium"
		>
			{contextHolder}
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
		</Layout>
	);
};

export default NewLogisticsTrip;
